module.exports = __webpack_public_path__ + "img/duct.dd198760.svg";